import update from 'immutability-helper';
import Constants from 'constants/actions';

const initialState = {
  timezoneOptions: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.SET_TIMEZONE_OPTIONS: {
      const { timezoneOptions } = action.data;

      return update(state, {
        timezoneOptions: { $set: timezoneOptions },
      });
    }

    default: {
      return state;
    }
  }
}

export const getOptions = state => state.timezoneOptions;
